import { createGlobalReferenceContext } from '@flex-packages/shared-react';
import axios from 'axios';
import { useContext } from 'react';

const AxiosContext = createGlobalReferenceContext(
  "axios-context",
  {
    instances: { json: axios, blob: axios }
  }
);
const AxiosBffContext = createGlobalReferenceContext(
  "axios-bff-context",
  {
    instances: { json: axios, blob: axios }
  }
);
const AxiosBaseContext = createGlobalReferenceContext(
  "axios-base-context",
  axios
);
const AxiosContextProvider = AxiosContext.Provider;
const AxiosBffContextProvider = AxiosBffContext.Provider;
const AxiosBaseContextProvider = AxiosBaseContext.Provider;
const useAxios = () => useContext(AxiosContext);
const useBffAxios = () => useContext(AxiosBffContext);
const useBaseAxios = () => useContext(AxiosBaseContext);

export { AxiosBaseContext, AxiosBaseContextProvider, AxiosBffContext, AxiosBffContextProvider, AxiosContext, AxiosContextProvider, useAxios, useBaseAxios, useBffAxios };
//# sourceMappingURL=context.mjs.map
